import React, { useContext } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MutationMessage from "../../Components/MutationMessage";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import * as api from "../../services";
import AppContext from "../../appContext";
import useLocalMoodboard from "../../UserBoards/useLocalMoodboard";
import listReducer from "../listReducer";
import AnalyserContext from "../analyserContext";

export default function SaveDialog({ moodboard, handleMoodboard }) {
  // local state
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId
    },
  } = useContext(AppContext); // clientId
  const history = useHistory(); // navigation
  const { analyser = { mode: "explore" } } = useContext(AnalyserContext);
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const addButton = {
    buttonText: t("common.buttons.add"),
    buttonIcon: AddOutlinedIcon,
    dialogTitle: t("moodboards.buttons.add"),
    dialogActionConfirm: t("moodboards.buttons.add"),
  };
  const saveButton = {
    buttonText: t("common.buttons.save"),
    buttonIcon: SaveOutlinedIcon,
    dialogTitle: t("moodboards.buttons.save"),
    dialogActionConfirm: t("moodboards.buttons.save"),
  };
  const text = analyser.mode === "explore" ? addButton : saveButton;

  // server state
  const { localMoodboard, refetchLocalMoodboard } = useLocalMoodboard();
  const moodBoardJSON = JSON.stringify(
    listReducer(
      localMoodboard,
      analyser.mode === "explore"
        ? { type: "ADD_MOODBOARD", payload: moodboard }
        : { type: "UPDATE_MOODBOARD", payload: moodboard }
    )
  );
  const mutation = useMutation(
    () => api.postLocalMoodboard({ clientId, moodBoardJSON, projectId, sessionId }),
    {
      onSuccess: (data) => {
        if (data.data?.status > 0) {
          refetchLocalMoodboard();
          history.push({
            pathname: "/moodboards",
            state: {
              from: "analyser",
            },
          });
        }
      },
    }
  ); // post the moodboards if user clicks on add

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (key) => (event) =>
    handleMoodboard({ [key]: event.target.value });
  const handleSwitch = (key) => (event) =>
    handleMoodboard({ [key]: event.target.checked });
  const handleSave = () => mutation.mutate();

  return (
    <div>
      <MutationMessage
        mutation={mutation}
        text={{
          loading: t("common.notifications.saveLoading"),
          success: t("common.notifications.saveSuccess"),
        }}
      />
      <Button
        variant="outlined"
        color="primary"
        startIcon={<text.buttonIcon />}
        onClick={handleClickOpen}
      >
        {text.buttonText}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{text.dialogTitle}</DialogTitle>
        <DialogContent>
          {/*    <DialogContentText>
                        {text.dialogText}
                    </DialogContentText> */}
          <TextField
            autoFocus
            margin="dense"
            label={t("common.placeholders.title")}
            type="text"
            fullWidth
            value={moodboard.title}
            onChange={handleChange("title")}
          />
          <TextField
            multiline
            margin="dense"
            label={t("moodboards.placeholders.description")}
            type="text"
            value={moodboard.description}
            onChange={handleChange("description")}
            fullWidth
          />
          <FormControlLabel
            control={
              <Switch
                checked={moodboard.expandDescription}
                onChange={handleSwitch("expandDescription")}
                name="checkedB"
                color="primary"
              />
            }
            label={t("moodboards.settings.expandDescription")}
            //style={{ paddingTop: 8 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            {t("common.actions.cancel")}
          </Button>
          <Button onClick={handleSave} color="primary">
            {text.dialogActionConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
